import React, { useEffect, useState } from "react";
import { Box, Paper, Tab } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import styles from "../../Leadgen.styles";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Maps from "./Maps";
import GoogleDrive from "./GoogleDrive";
import { receiveDocsGoogleDriveRequest } from "../../actions/docsGoogleDrive";
import { selectLeadgen } from "../../selectors";
import { showAddressOnMap } from "../../actions/objects";
import { selectSuperAdmin } from '../../../super-admin/selectors';
import type { RootState } from '../../../../reducers';

interface MapGoogleDriveBlockProps {
  mapStyles: object;
  address?: any;
  entityId?: string;
  objectId?: string;
  addressForMap?: string;
  mapRequestId?: number;
  entityObjectsList?: any;
  objectsAmount?: any;
  driveConnectionCheck: boolean;
}

const initialTab = "map";

const MapGoogleDriveBlock = (props: MapGoogleDriveBlockProps) => {
  const { mapStyles, address, entityId, objectId, driveConnectionCheck, mapRequestId } = props;
  const dispatch = useDispatch();
  const [value, setValue] = useState(initialTab);
  const [type, setType] = useState("");
  const [changeAddress, setChangeAddress] = useState("");
  const [id, setId] = useState("");
  const [addressForMapDisplaying, setAddressForMapsDisplaying] = useState("");

  useEffect(() => {
    if (entityId) {
      setType("entity");
      setId(entityId);
    }
    if (objectId) {
      setType("object");
      setId(objectId);
    }
    setValue(initialTab);
    setAddressForMapsDisplaying(address);
    if (address) {
      setChangeAddress(address);
    }
  }, [entityId, objectId, address]);

  useEffect(() => {
    if (value === "googleDrive") {
      if (driveConnectionCheck) {
        if (type === "entity") {
          dispatch(receiveDocsGoogleDriveRequest({ type, id: entityId }));
        }
        if (type === "object") {
          dispatch(receiveDocsGoogleDriveRequest({ type, id: objectId }));
        }
      }
    }
    if (value === "map") {
      dispatch(showAddressOnMap({ address: changeAddress, requestId: Date.now() }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChangeTabs = (_event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <>
      <Paper sx={styles.containerMap}>
        <TabContext value={value}>
          <Box sx={styles.boxTabs}>
            <TabList
              onChange={handleChangeTabs}
              variant="fullWidth"
              aria-label="tabs API"
            >
              <Tab label="Map" value="map" sx={styles.contentTitleMain} />
              <Tab
                label="Google Drive"
                value="googleDrive"
                sx={styles.contentTitleMain}
              />
            </TabList>
          </Box>
          <TabPanel value="map" sx={styles.contentTabPanel}>
            <Maps
              mapStyles={mapStyles}
              addressForMapDisplaying={addressForMapDisplaying}
              mapRequestId={mapRequestId}
              tab={value}
            />
          </TabPanel>
          <TabPanel value="googleDrive" sx={styles.contentTabPanel}>
            <GoogleDrive type={type} id={id} />
          </TabPanel>
        </TabContext>
      </Paper>
    </>
  );
};

function mapStateToProps(state: RootState) {
  const { entityObjectsList, objectsAmount, addressForMap, mapRequestId } =
    selectLeadgen(state);
  const { driveConnectionCheck } =
    selectSuperAdmin(state);
  return { entityObjectsList, objectsAmount, addressForMap, driveConnectionCheck, mapRequestId };
}

export default connect(mapStateToProps)(MapGoogleDriveBlock);
